var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["MESSAGE"] = "message";
    MESSAGE_TYPE["MENU"] = "menu";
    MESSAGE_TYPE["COMPONENT"] = "component";
})(MESSAGE_TYPE || (MESSAGE_TYPE = {}));

export { MESSAGE_TYPE };
//# sourceMappingURL=MessageTypes.js.map
